import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var getOptions = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _params$targetFieldCo, targetFieldCodes, arr, fetchResult, ret;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _params$targetFieldCo = params.targetFieldCodes, targetFieldCodes = _params$targetFieldCo === undefined ? [] : _params$targetFieldCo;
            arr = targetFieldCodes.map(function (targetFieldCode) {
              return _getOptions(_extends({}, params, {
                targetFieldCode: targetFieldCode
              }));
            });
            _context.next = 4;
            return _Promise.all(arr);

          case 4:
            fetchResult = _context.sent;
            ret = {};

            fetchResult.forEach(function (v) {
              ret = _extends({}, ret, v);
            });
            return _context.abrupt('return', ret);

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getOptions() {
    return _ref.apply(this, arguments);
  };
}();

import _getOptions from './getOptions';
export default {
  getOptions: getOptions
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/ecs/index.js
// module id = 141
// module chunks = 0